<template>
  <div class="p-grid p-col-12 p-lg-12">
    <div class="p-col-12 p-md-5">
      <HomeTasksList ref="tasksList" />
    </div>
    <div class="p-col-12 p-md-4">
      <HomeAlerts />
    </div>
    <div class="p-col-12 p-md-3">
      <HomeFleet @reservation-ended="$refs.tasksList.refreshVehicleReservation()" />
    </div>
  </div>
</template>

<script>
import HomeTasksList from "./HomeTasksList";
import HomeFleet from "./HomeFleet.vue";
import HomeAlerts from "./HomeAlerts.vue";
export default {
  name: "Home",
  components: {
    HomeTasksList,
    HomeFleet,
    HomeAlerts,
  },
  computed: {
    currentUser() {
      if (this.$store.state.auth.loggedIn) {
        return this.$store.state.auth.user;
      }
      return null;
    },
  },
  created() {
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
  },
};
</script>
